import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import AllAccessoriesphoto from "../images/All Accessories.jpg";
import leptop from "../images/LAPTOP.jpg";
import keyboard from "../images/KEYBOARD.jpg"
import mousepad from "../images/MOUSE PAD.jpg";
import usb from "../images/CPU.jpg"
import mouse from "../images/MOUSE.jpg";
import Computerset from "../images/COMPUTER SET.jpg";

import hp32gbpendrive from "../images/HP Pen drive 32gb.jpg";
import hp64gbpendrive from  "../images/HP 64 GB.jpg"
import hp128gbpendrive from "../images/HP-128gb-.jpg";

function AllAccessories() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <div className="cctvfotageberhampore">
        <div className="album py-1">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">All Accessories</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br />
      <div className="album py-1">

        <div className="container ">
          <div className="row">

            <div className="col-md-8">
              <h1 style={{ color: "#030D54" }}> <b>All Accessories</b></h1>
              <div className="col-md-4 mt-3" >
                <hr />
              </div>

              <p className='justify'>We provide a complete range of high-quality accessories to support all your security, electrical, and digital setup needs. From CCTV connectors, cables, adapters, DVR accessories, power supplies, and mounting equipment to computer accessories, networking tools, smart home add-ons, and electrical fittings, we ensure durable and reliable products for every requirement.</p>
              <br />

              <a className='mb-3' href='tel: 9064797437'>Help Line No. 9064797437</a>
              <br />
              <br />
            </div>
            <div className="col-md-4 mt-3" >
              <img src={AllAccessoriesphoto} className="d-block w-100" alt="AllAccessories" />

            </div>
          </div>

        </div>
      </div>
      <div className='computershopberhampore'>
           <br />
      <div className="album py-1">

        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={leptop} className="card-img-top" alt="leptop" />
                <div className='card-body'>
                  <h5 style={{color:"darkblue"}} className='mb-1'><b>Laptop</b></h5>
                  <p className='mb-0'>Best Brand Laptop Available</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={keyboard} className="card-img-top" alt="keyboard" />
                <div className='card-body'>
               <h5 style={{color:"darkblue"}} className='mb-1'><b>Keyboard</b></h5>
                  <p className='mb-0'>Best Brand Keyboard Available</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={mousepad} className="card-img-top" alt="mousepad"/>
                <div className='card-body'>
                   <h5 style={{color:"darkblue"}} className='mb-1'><b>Mouse Pad</b></h5>
                  <p className='mb-0'>Best Brand Mouse Pad Available</p>
                </div>
              </div>
            </div>

             <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={usb} className="card-img-top" alt="cpu_computer"/>
                <div className='card-body'>
                   <h5 style={{color:"darkblue"}} className='mb-1'><b>CPU</b></h5>
                  <p className='mb-0'>Best Brand CPU Available</p>
                </div>
              </div>
            </div>


             <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={mouse} className="card-img-top" alt="mouse"/>
                <div className='card-body'>
                   <h5 style={{color:"darkblue"}} className='mb-1'><b>Mouse</b></h5>
                  <p className='mb-0'>Best Brand Mouse  Available</p>
                </div>
              </div>
            </div>


             <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={Computerset} className="card-img-top" alt="Computerset"/>
                <div className='card-body'>
                   <h5 style={{color:"darkblue"}} className='mb-1'><b>Computer Set</b></h5>
                  <p className='mb-0'>Best Brand Computer Set Available</p>
                </div>
              </div>

              
            </div>


              <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={hp32gbpendrive} className="card-img-top" alt="hp32gbpendrive"/>
                <div className='card-body'>
                   <h5 style={{color:"darkblue"}} className='mb-1'><b>HP 32GB pendrive</b></h5>
                  <p className='mb-0'>Best Brand pendrive Available</p>
                </div>
              </div>

              
            </div>


              <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={hp64gbpendrive} className="card-img-top" alt="hp64gbpendrive"/>
                <div className='card-body'>
        <h5 style={{color:"darkblue"}} className='mb-1'><b>HP 64GB pendrive</b></h5>
                  <p className='mb-0'>Best Brand pendrive Available</p>
                </div>
              </div>

              
            </div>


              <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={hp128gbpendrive} className="card-img-top" alt="hp128gbpendrive"/>
                <div className='card-body'>
       <h5 style={{color:"darkblue"}} className='mb-1'><b>HP 128GB pendrive</b></h5>
                  <p className='mb-0'>Best Brand pendrive Available</p>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </div>
         <br />
         <br/>
      </div>

   
    </div>
  )
}

export default AllAccessories